import * as React from 'react';
import { formatDate } from '../utils/format-date';
import { useIntlFormat } from './use-intl-format';

export function useFormatDate(date?: Date, region = 'en-au'): string {
    const fmt = useIntlFormat(region);
    /*
     * The `formatDate` function takes an optional fallback text for invalid or undefined dates.
     * It would be nice to add an internationalized placeholder here.
     */
    return React.useMemo(() => formatDate(fmt, date), [fmt, date]);
}
